import { useState } from 'react'
import useGetEvenParticipantTemplateList from 'entity/event/useGetEvenParticipantTemplateList'
import TStyle from 'shared/style/tableStyle'
import Style from './style'
import DefaultButton from 'shared/ui/DefaultButton'
import {convertStatusAsName} from 'shared/constant/lookup/eventState'
import Pagenation from 'widget/Pagenation'
import SortableHeader from "shared/ui/SortableHeader";
import TableLoading from "shared/ui/TableLoading";
import timestampCalculator from 'shared/lib/timestampCalculator'
import warningIcon from 'shared/assets/ic_warning.svg'

const UploadParticipantList = ({ reloadTrigger }) => {
	const [evenParticipantTemplateList, isLoading] = useGetEvenParticipantTemplateList(reloadTrigger)
	const participantList = evenParticipantTemplateList?.data?.list
	const maxPage = evenParticipantTemplateList?.data?.max_page
  const [tooltipVisible, setTooltipVisible] = useState({})
  const [downloadingItems, setDownloadingItems] = useState({})

  const handleMouseEnter = (index) => {
    setTooltipVisible(prev => ({ ...prev, [index]: true }))
  }

  const handleMouseLeave = (index) => {
    setTooltipVisible(prev => ({ ...prev, [index]: false }))
  }

  const getTooltipMessage = (status) => {
    if (status === 'failed') {
      return '최신 템플릿을 다운로드하세요.'
    }
    if (status === 'unsuccess') {
      return 'Excel 파일의 오류를 수정한 후 다시 업로드해 주세요.'
    }
    return ''
  }

  const shouldShowWarningIcon = (status) => {
    return status === 'failed' || status === 'unsuccess'
  }

  const shouldDisableButton = (status) => {
    return status === 'failed'
  }

  const handleDownload = async (elem, e) => {
    e.stopPropagation()
    
    if (shouldDisableButton(elem?.status)) {
        return
    }

    const itemId = elem.idx
    setDownloadingItems(prev => ({ ...prev, [itemId]: true }))

    const downloadUrl = elem?.error_s3_url || elem?.original_s3_url

    try {
      const response = await fetch(downloadUrl, {
        method: 'GET'
      })

      if (response.ok) {
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = `결과-${elem.original_filename}.xlsx`
        link.style.display = 'none'
        
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.URL.revokeObjectURL(url)
      } else {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`)
      }

    } catch (error) {
      const link = document.createElement('a')
      link.href = downloadUrl
      link.download = `결과-${elem.original_filename}.xlsx`
      link.target = '_blank'
      link.style.display = 'none'
      
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }

    setTimeout(() => {
      setDownloadingItems(prev => {
        const newState = { ...prev }
        delete newState[itemId]
        return newState
      })
    }, 500)
  }

	return (
		<>
      <TableLoading isLoading={isLoading}>
        <TStyle.TableDiv>
          <TStyle.TableInner>
            <TStyle.TableRow $title>
              {tableHeadList.map((elem, index) => (
                <TStyle.Data key={index} $title $size={sizeList[index]}>
                  <SortableHeader sortKey={elem.sortKey}>
                    {elem.label}
                  </SortableHeader>
                </TStyle.Data>
              ))}
            </TStyle.TableRow>
            {participantList?.map((elem, index) => {
              return (
                <TStyle.TableRow
                  key={index}
                  $odd={index % 2 === 1}
                >
                  <TStyle.Data $size={sizeList[0]}>{elem?.original_filename}</TStyle.Data>
                  <TStyle.Data $size={sizeList[1]}>{elem?.total_participant ?? '-'}</TStyle.Data>
                  <TStyle.Data $size={sizeList[2]}>{elem?.total_ticket_issued ?? '-'}</TStyle.Data>
                  <TStyle.Data $size={sizeList[3]}>
                    <Style.StatusWrapper>
                      {convertStatusAsName[elem?.status]}
                      {shouldShowWarningIcon(elem?.status) && (
                        <Style.TooltipContainer
                          onMouseEnter={() => handleMouseEnter(index)}
                          onMouseLeave={() => handleMouseLeave(index)}
                        >
                          <Style.WarningIcon src={warningIcon} alt="warning" />
                          <Style.TooltipContent $visible={tooltipVisible[index]}>
                            {getTooltipMessage(elem?.status)}
                          </Style.TooltipContent>
                        </Style.TooltipContainer>
                      )}
                    </Style.StatusWrapper>
                  </TStyle.Data>
                  <TStyle.Data $size={sizeList[4]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                  <TStyle.Data $size={sizeList[5]}>
                    <DefaultButton
                      small
                      fitWidth
                      clickEvent={(e) => handleDownload(elem, e)}
                      deactive={shouldDisableButton(elem?.status)}
                      loading={downloadingItems[elem.idx]}
                    >
                      다운로드
                    </DefaultButton>
                  </TStyle.Data>
                </TStyle.TableRow>
              )
            })}
          </TStyle.TableInner>
        </TStyle.TableDiv>
      </TableLoading>

			<Pagenation maxPage={maxPage} />
		</>
	)
}

export default UploadParticipantList

const sizeList = [
	'expand',
	'long',
	'long',
	'long',
	'longCenter',
	'mediumCenter',
]
const tableHeadList = [
	{label: "파일 이름", sortKey: "original_filename"},
  {label: "총 참가자 수", sortKey: "total_participant"},
  {label: "총 티켓 발행량", sortKey: "total_ticket_issued"},
  {label: "상태", sortKey: "status"},
  {label: "업로드 날짜", sortKey: "created_at"},
  {label: ""},
]
